import HttpFactory from '../factory'

class IDValidatorModule extends HttpFactory {

  async checkDocument({ image, documentType}) {
    return await this.call(`post`, `/id_validator/check_document`, { image, document_type: documentType });
  }

  async convertImg2PDF(pdfFile) {
    return await this.call(`post`, `/id_validator/convert_img_to_pdf`, { pdf_file: pdfFile });
  }

}

export default IDValidatorModule
